export const Constants = {
  TAG_NAME: 'pop-purchases-and-sales-chart-component',
  ISSUER_LABEL: 'Issuer',
  PREV_QUARTER_PORTFOLIO_WEIGHT_LABEL: 'Previous quarter % of portfolio',
  PORTFOLIO_WEIGHT_LABEL: '% of portfolio',
  Y_AXIS_LABEL: '% of Portfolio',
  CHANGE_LABEL: '% change from previous quarter',
} as const;
